import React, { useState } from "react"; 
  
function RadioComponent({state,dispatch}) { 
    const [ 
        selectedValue, 
        setSelectedValue, 
    ] = useState("option1"); 
    const [ 
        fromDate, 
        setFromDate, 
    ] = useState(null);
    
    
    const handleRadioChange = ( 
        value 
    ) => { 
        setSelectedValue(value); 
        if (value === 'option1'){
            setFromDate(null);  
        }
        console.log({fromDate});
        
    }; 
  
    const styles = { 
        container: { 
            display: "flex", 
            flex: 1, 
            justifyContent: "center", 
            alignItems: "center", 
        }, 
        heading: { 
            color: "green", 
            textAlign: "center", 
        }, 
        radioGroup: { 
            display: "flex", 
            flexDirection: "row", 
            alignItems: "center", 
            justifyContent: 
                "space-between", 
            marginTop: "20px", 
            borderRadius: "8px", 
            backgroundColor: "white", 
            padding: "10px", 

        }, 
        radioButton: { 
            display: "flex", 
            flexDirection: "row", 
            alignItems: "center", 
        }, 
        radioLabel: { 
            marginLeft: "9px", 
            fontSize: "17px", 
            color: "#333", 
        }, 
    }; 
  
    return ( 
        <div> 
            
            <div 
                style={styles.container} 
            > 
                <div 
                    style={ 
                        styles.radioGroup 
                    } 
                > 
                    <div 
                        style={ 
                            styles.radioButton 
                        } 
                    > 
                        <input 
                            type="radio"
                            id="option1"
                            name="filterType"
                            value='all'

                            checked={ 
                                state.filter.filterType === 
                                "all"
                            } 
                            onChange={(e) => 
                                // handleRadioChange( 
                                //     "option1"
                                // ) 
                                dispatch({ type: 'filter', filter: {
                                    ...state.filter,
                                    filterType: e.target.value
                                }})
                            } 
                        /> 
                        <label 
                            htmlFor="option1"
                            style={ 
                                styles.radioLabel 
                            } 
                        > 
                            All 
                        </label> 
                    </div> 
  
                    <div 
                        style={ 
                            styles.radioButton 
                        } 
                    > 
                        <input 
                            type="radio"
                            id="option2"
                            name="filterType"
                            value='date'
                            checked={ 
                                state.filter.filterType === 
                                "date"
                            }  
                            onChange={(e) => 
                                // handleRadioChange( 
                                //     "option1"
                                // ) 
                                dispatch({ type: 'filter', filter: {
                                    ...state.filter,
                                    filterType: e.target.value
                                }})
                            }
                        /> 
                        <label 
                            htmlFor="option2"
                            style={ 
                                styles.radioLabel 
                            } 
                        > 
                            Date range 
                        </label> 
                    </div> 
  
                    
                </div> 
            </div> 
        </div> 
    ); 
} 
  
export default RadioComponent; 